import {
  LIST_LAB_TEST_METHOD_REQUEST,
  LIST_LAB_TEST_METHOD_SUCCESS,
  LIST_LAB_TEST_METHOD_FAIL,
  LIST_LAB_TEST_METHOD_SUMMARY_REQUEST,
  LIST_LAB_TEST_METHOD_SUMMARY_SUCCESS,
  LIST_LAB_TEST_METHOD_SUMMARY_FAIL,
  CREATE_LAB_TEST_METHOD_REQUEST,
  CREATE_LAB_TEST_METHOD_SUCCESS,
  CREATE_LAB_TEST_METHOD_FAIL,
  DETAIL_LAB_TEST_METHOD_REQUEST,
  DETAIL_LAB_TEST_METHOD_SUCCESS,
  DETAIL_LAB_TEST_METHOD_FAIL,
  UPDATE_LAB_TEST_METHOD_REQUEST,
  UPDATE_LAB_TEST_METHOD_SUCCESS,
  UPDATE_LAB_TEST_METHOD_FAIL,
  DELETE_LAB_TEST_METHOD_REQUEST,
  DELETE_LAB_TEST_METHOD_SUCCESS,
  DELETE_LAB_TEST_METHOD_FAIL,
  RESET_STATE_LAB_TEST_METHOD
} from '../../constants/lab-test-methods'

const initialState = {
  loading: false,
  labTestMethods: [],
  labTestMethod: {},
  labTestMethodSummary:[],
  error: null,
  pageable: {}
}

const labTestMethodsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_LAB_TEST_METHOD_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_LAB_TEST_METHOD_SUCCESS:
      return {
        ...state,
        loading: false,
        labTestMethods: action.payload,
        pageable: action.pageable
      }
    case LIST_LAB_TEST_METHOD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        labTestMethods: []
      }
    case LIST_LAB_TEST_METHOD_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_LAB_TEST_METHOD_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        labTestMethodSummary: action.payload
      }
    case LIST_LAB_TEST_METHOD_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_LAB_TEST_METHOD_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_LAB_TEST_METHOD_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        labTestMethods: [...state.labTestMethods, action.payload]
      }
    case CREATE_LAB_TEST_METHOD_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_LAB_TEST_METHOD_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_LAB_TEST_METHOD_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        labTestMethod: action.payload
      }
    case DETAIL_LAB_TEST_METHOD_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_LAB_TEST_METHOD_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_LAB_TEST_METHOD_SUCCESS:
      const labTestMethod = action.payload
      const labTestMethodIndex = state.labTestMethods.findIndex((labTestMethod) => labTestMethod.id === action.id)
      const updatedLabTestMethods = [...state.labTestMethods]
      updatedLabTestMethods[labTestMethodIndex] = labTestMethod

      return {
        ...state,
        loadingUpdate: false,
        labTestMethods: updatedLabTestMethods
      }
    case UPDATE_LAB_TEST_METHOD_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_LAB_TEST_METHOD_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_LAB_TEST_METHOD_SUCCESS:
      const labTestMethodId = action.payload
      const labTestMethodDeleteIndex = state.labTestMethods.findIndex((labTestMethod) => labTestMethod.id === labTestMethodId)
      const updatedLabTestMethodsAfterDelete = [...state.labTestMethods]
      updatedLabTestMethodsAfterDelete.splice(labTestMethodDeleteIndex, 1)

      return {
        ...state,
        loadingDelete: false,
        labTestMethods: updatedLabTestMethodsAfterDelete
      }
    case DELETE_LAB_TEST_METHOD_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    case RESET_STATE_LAB_TEST_METHOD:
      return initialState
    default:
      return state
  }
}

export default labTestMethodsReducer